import { useMutation, type useQueryClient } from "@tanstack/react-query";
import * as API from "./index";

export const gymQueryFactory = {
  gymInfo: "gymInfo" as const,
  getGymInfo: () => ({
    queryKey: [gymQueryFactory.gymInfo],
    queryFn: () => API.getGymInfo(),
  }),
};

export const gymMutationFactory = {
  updateGymInfo: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.updateGymInfo,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [gymQueryFactory.gymInfo],
          });
          toast.success("Gym info updated successfully");
        },
      });
    };
  },
  updateGymLogo: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.updateGymLogo,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [gymQueryFactory.gymInfo],
          });
          toast.success("Logo updated successfully");
        },
      });
    };
  },
  updateGymBanner: () => {
    return (queryClient: ReturnType<typeof useQueryClient>) => {
      return useMutation({
        mutationFn: API.updateGymBanner,
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [gymQueryFactory.gymInfo],
          });
          toast.success("Gym banner updated successfully");
        },
      });
    };
  },
};
